import roleService from '../../api/role'
const state = {
  roles: [],
  internalRoles: [],
  externalRoles: []
}

const mutations = {
  setRoles (state, roles) {
    state.roles = roles
  },
  setInternalRoles (state, roles) {
    state.internalRoles = roles
  },
  setExternalRoles (state, roles) {
    state.externalRoles = roles
  }
}

const actions = {
  getRoles ({ commit }) {
    roleService.getRoles().then(response => {
      commit('setRoles', response.data)
    }).catch(error => {
      console.log(error)
    })
  },
  getInternalRoles ({ commit }) {
    roleService.getInternalRoles().then(response => {
      commit('setInternalRoles', response.data)
    }).catch(error => {
      console.log(error)
    })
  },
  getExternalRoles ({ commit }) {
    roleService.getExternalRoles().then(response => {
      commit('setExternalRoles', response.data)
    }).catch(error => {
      console.log(error)
    })
  },
  createRole ({ commit }, role) {
    return new Promise((resolve, reject) => {
      roleService.createRole(role).then((res) => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  updateRole ({ commit }, role) {
    return new Promise((resolve, reject) => {
      roleService.updateRole(role).then((res) => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
